var map = {
	"./another-movie-db/description.md": 4470,
	"./another-movie-db/textProps.json": 9746,
	"./data-services/description.md": 951,
	"./data-services/textProps.json": 4605,
	"./esports-news-api/description.md": 6016,
	"./esports-news-api/textProps.json": 6623,
	"./fidelity-1/description.md": 346,
	"./fidelity-1/textProps.json": 2864,
	"./fidelity-2/description.md": 2709,
	"./fidelity-2/textProps.json": 6186,
	"./hump-day-golf-league/description.md": 6209,
	"./hump-day-golf-league/textProps.json": 7574,
	"./kyk-share-improvements/description.md": 2393,
	"./kyk-share-improvements/textProps.json": 9927,
	"./pokeapi-app/description.md": 4015,
	"./pokeapi-app/textProps.json": 4061,
	"./roche-bros-redesign/description.md": 4245,
	"./roche-bros-redesign/textProps.json": 8981,
	"./snapface/description.md": 6,
	"./snapface/textProps.json": 6347,
	"./streamlit-craigslist-used-cars/description.md": 2965,
	"./streamlit-craigslist-used-cars/textProps.json": 4425,
	"./todoist-notion-sync/description.md": 5303,
	"./todoist-notion-sync/textProps.json": 9330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2394;